import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/apps/assets/images/star.png'


const _withScopeId = n => (_pushScopeId("data-v-9aa961c4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "schedule" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "schedule__title title" }, [
  /*#__PURE__*/_createTextVNode(" Рекомендованный график "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" посещений гигиениста ")
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "schedule__subtitle text subtitle" }, " При соблюдении графика посещений вы сможете избежать трат на лечение и проблем с зубами ", -1))
const _hoisted_4 = { class: "schedule__content" }
const _hoisted_5 = { class: "schedule__list" }
const _hoisted_6 = { class: "schedule__next-date--header" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "small-text subtitle" }, "Следующий визит", -1))
const _hoisted_8 = { class: "schedule__next-date--paragraph text" }
const _hoisted_9 = { class: "schedule__calendar" }
const _hoisted_10 = { class: "schedule__block" }
const _hoisted_11 = { class: "schedule__year text" }
const _hoisted_12 = { class: "schedule__month--list" }
const _hoisted_13 = { class: "schedule__month--title small-text" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "star",
  class: "healthful__star",
  src: _imports_0
}, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "healthful__congratulation" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "healthful__text" }, [
    /*#__PURE__*/_createTextVNode(" Поздравляем! Вы "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" достигли "),
    /*#__PURE__*/_createElementVNode("span", null, [
      /*#__PURE__*/_createTextVNode(" здорового "),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" уровня ")
    ]),
    /*#__PURE__*/_createTextVNode(" чистоты зубов ")
  ])
], -1))
const _hoisted_16 = {
  key: 0,
  class: "schedule__block"
}
const _hoisted_17 = { class: "schedule__year text" }
const _hoisted_18 = { class: "schedule__month--list" }
const _hoisted_19 = { class: "schedule__month--title small-text" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "star",
  class: "healthful__star",
  src: _imports_0
}, null, -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "healthful__congratulation" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "healthful__text" }, [
    /*#__PURE__*/_createTextVNode(" Поздравляем! Вы "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" достигли "),
    /*#__PURE__*/_createElementVNode("span", null, [
      /*#__PURE__*/_createTextVNode(" здорового "),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" уровня ")
    ]),
    /*#__PURE__*/_createTextVNode(" чистоты зубов ")
  ])
], -1))

import { computed } from 'vue'
import { AppointmentType } from '@/shared/types'
import { PlaqueReportController } from '@/pages/PlaqueReportPage/plaqueReport'

interface Props {
  appointments: AppointmentType
  plaqueReportController: PlaqueReportController
}


export default /*#__PURE__*/_defineComponent({
  props: {
    appointments: null,
    plaqueReportController: null
  },
  setup(__props: any) {

const props = __props as {
  appointments: AppointmentType
  plaqueReportController: PlaqueReportController
}



function monthAndYearEquals(point, month, year) {
  const monthPoint = point.date.split(' ')[0]
  const isMay =
    point.date.includes('Ма') &&
    month.includes('Ма') &&
    month.length === 3 &&
    monthPoint.length === 3
  const isMatchingYears = point.date.includes(year.slice(2))

  if (isMay) {
    return isMatchingYears
  }

  const isMatchingMonths = month.includes(point.date.slice(0, 3))

  return isMatchingMonths && isMatchingYears
}

const indexFirstAppointment = computed(() => {
  let index = -1

  for (let i = 0; i < monthsLeftCalendar.value.length; i++) {
    if (monthsLeftCalendar.value[i].value !== undefined) {
      index = i
      return index
    }
  }
  for (let i = 0; i < monthsRightCalendar.value.length; i++) {
    if (monthsRightCalendar.value[i].value !== undefined) {
      index = i
      return index
    }
  }
})

const years = computed(() =>
  props.plaqueReportController.getAppointmentsYears()
)

const appointmentsDates = computed(() =>
  props.appointments?.longDates.filter(Boolean)
)

const months = [
  'Январь',
  'Февраль',
  'Март',
  'Апрель',
  'Май',
  'Июнь',
  'Июль',
  'Август',
  'Сентябрь',
  'Октябрь',
  'Ноябрь',
  'Декабрь',
]

const firstHealthfulValue = computed(() => {
  return appointmentsDates.value?.find((point) => point.value <= 10)
})

const monthsLeftCalendar = computed(() => {
  return months.map((month) => {
    const findMonth = appointmentsDates.value?.find((date) =>
      monthAndYearEquals(date, month, years.value[0])
    )

    if (findMonth) {
      return {
        label: month,
        value: findMonth.value,
      }
    }

    return {
      label: month,
    }
  })
})

const monthsRightCalendar = computed(() => {
  if (!years.value[1]) {
    return
  }

  return months.map((month) => {
    const findMonth = appointmentsDates.value?.find((date) =>
      monthAndYearEquals(date, month, years.value[1])
    )

    if (findMonth) {
      return {
        label: month,
        value: findMonth.value,
      }
    }

    return {
      label: month,
    }
  })
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(appointmentsDates), (date, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "schedule__next-date text"
          }, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", {
                class: _normalizeClass([{
                'schedule__next-date--circle_healthful': index !== 0,
                'schedule__next-date--circle_unsafe': index === 0,
              }, "schedule__next-date--circle"])
              }, null, 2),
              _hoisted_7
            ]),
            _createElementVNode("p", _hoisted_8, _toDisplayString(date.date), 1)
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("h4", _hoisted_11, _toDisplayString(_unref(years)[0]), 1),
          _createElementVNode("div", _hoisted_12, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(monthsLeftCalendar), (month, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "schedule__month"
              }, [
                _createElementVNode("h4", _hoisted_13, _toDisplayString(month.label), 1),
                _createElementVNode("div", {
                  class: _normalizeClass([{
                  appointment_healthful:
                    Number.isFinite(month.value) &&
                    index !== _unref(indexFirstAppointment),
                  appointment_unsafe: index === _unref(indexFirstAppointment),
                }, "schedule__month--block"])
                }, [
                  (
                    _unref(firstHealthfulValue) &&
                    monthAndYearEquals(
                      _unref(firstHealthfulValue),
                      month.label,
                      _unref(years)[0]
                    )
                  )
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _hoisted_14,
                        _hoisted_15
                      ], 64))
                    : _createCommentVNode("", true)
                ], 2)
              ]))
            }), 128))
          ])
        ]),
        (_unref(years)[1])
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
              _createElementVNode("h4", _hoisted_17, _toDisplayString(_unref(years)[1]), 1),
              _createElementVNode("div", _hoisted_18, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(monthsRightCalendar), (month, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "schedule__month"
                  }, [
                    _createElementVNode("h4", _hoisted_19, _toDisplayString(month.label), 1),
                    _createElementVNode("div", {
                      class: _normalizeClass([{
                  'appointment_healthful-light': Number.isFinite(month.value),
                }, "schedule__month--block"])
                    }, [
                      (
                    _unref(firstHealthfulValue) &&
                    monthAndYearEquals(
                      _unref(firstHealthfulValue),
                      month.label,
                      _unref(years)[1]
                    )
                  )
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _hoisted_20,
                            _hoisted_21
                          ], 64))
                        : _createCommentVNode("", true)
                    ], 2)
                  ]))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})